module.exports = __webpack_public_path__ + "img/navbrand.dad4750a.svg";